import React from 'react';
import { NavLink } from 'react-router-dom';
import { getSliders, resolveImageUrl } from '../../services/api';

const defaultSlides = [
    {
        id: "slide-1",
        tag: "bs clads • SINCE 2010",
        title: "ALUMINUM COMPOSITE PANEL (ACP) FRONT ELEVATION",
        description: "Transforming buildings with durable, weather-resistant ACP front elevation and modern architectural paneling in Coimbatore.",
        image: require('./../../images/products/acp_cladding.jpg'),
        link: "/product/acp-front-elevation",
        btnText: "Explore ACP Front Elevation"
    },
    {
        id: "slide-2",
        tag: "HIGH-PERFORMANCE FACADES",
        title: "FACADE GLAZING & CURTAIN WALLS",
        description: "Modern Facade Glazing systems engineered for durability, performance, and refined aesthetics.",
        image: require('./../../images/products/facade_glazing.jpg'),
        link: "/product/facade-glazing",
        btnText: "Discover Facade Glazing"
    },
    {
        id: "slide-3",
        tag: "DURABLE SAFETY GLASS",
        title: "TOUGHENED GLASS",
        description: "Toughened Glass is a strong and durable safety glass designed for better strength, safety, and long-lasting performance in modern building applications.",
        image: require('./../../images/products/front_elevation.jpg'),
        link: "/product/toughened-glass",
        btnText: "View Toughened Glass"
    }
];

const getCachedSliders = () => {
    if (typeof window === 'undefined') return null;
    try {
        const stored = sessionStorage.getItem('bs_home_sliders');
        if (stored) return JSON.parse(stored);
    } catch (e) {}
    return null;
};

const setCachedSliders = (slides) => {
    if (!slides || typeof window === 'undefined') return;
    try {
        sessionStorage.setItem('bs_home_sliders', JSON.stringify(slides));
    } catch (e) {}
};

class Slider extends React.Component {
    constructor(props) {
        super(props);
        const cached = getCachedSliders();
        this.state = {
            slides: cached || null,
            hasFetched: !!cached,
            activeSlide: 0
        };
        this.timer = null;
    }

    componentDidMount() {
        this.startAutoPlay();
        this.loadSliders();
    }

    componentWillUnmount() {
        this.stopAutoPlay();
    }

    resolveImageUrl = (img) => {
        if (!img) return require('./../../images/products/acp_cladding.jpg');
        if (typeof img === 'string') {
            if (img.startsWith('http://') || img.startsWith('https://') || img.startsWith('data:')) return img;
            return resolveImageUrl(img);
        }
        return img;
    };

    loadSliders = async () => {
        try {
            const fetched = await getSliders(null);
            if (fetched && Array.isArray(fetched) && fetched.length > 0) {
                const formatted = fetched.map(s => ({
                    id: s.id || `slide-${Math.random()}`,
                    tag: s.badge !== undefined ? s.badge : (s.tag !== 'BEST SIGNS' ? (s.tag || '') : ''),
                    title: s.title || '',
                    description: s.description || s.shortDesc || '',
                    image: this.resolveImageUrl(s.image || s.mainImage),
                    link: s.btn1Link || s.link || '/products',
                    btnText: s.btn1Text || s.btnText || 'Explore Products'
                }));
                setCachedSliders(formatted);
                this.setState({ slides: formatted, hasFetched: true });
            } else {
                this.setState({ slides: defaultSlides, hasFetched: true });
            }
        } catch (e) {
            this.setState({ slides: defaultSlides, hasFetched: true });
        }
    };

    startAutoPlay = () => {
        this.stopAutoPlay();
        this.timer = setInterval(() => {
            const slideCount = (this.state.slides || defaultSlides).length || 1;
            this.setState(prevState => ({
                activeSlide: (prevState.activeSlide + 1) % slideCount
            }));
        }, 6000);
    };

    stopAutoPlay = () => {
        if (this.timer) clearInterval(this.timer);
    };

    goToSlide = (index) => {
        this.setState({ activeSlide: index });
        this.startAutoPlay();
    };

    prevSlide = () => {
        const slideCount = (this.state.slides || defaultSlides).length || 1;
        this.setState(prevState => ({
            activeSlide: (prevState.activeSlide - 1 + slideCount) % slideCount
        }));
        this.startAutoPlay();
    };

    nextSlide = () => {
        const slideCount = (this.state.slides || defaultSlides).length || 1;
        this.setState(prevState => ({
            activeSlide: (prevState.activeSlide + 1) % slideCount
        }));
        this.startAutoPlay();
    };

    render() {
        const { slides, activeSlide, hasFetched } = this.state;
        const displaySlides = slides || (hasFetched ? defaultSlides : []);
        const currentSlide = displaySlides[activeSlide] || displaySlides[0];

        // While loading for the first time, old default images NEVER show up
        const slideBgUrl = currentSlide ? currentSlide.image : null;

        return (
            <div 
                className="hero-slider-section" 
                style={{ 
                    position: 'relative', 
                    width: '100%', 
                    height: 'calc(100vh - 40px)', 
                    maxHeight: 'calc(100vh - 40px)', 
                    minHeight: '500px', 
                    marginTop: '0px', 
                    paddingTop: '80px', 
                    overflow: 'hidden', 
                    backgroundColor: '#111111',
                    boxSizing: 'border-box'
                }}
            >
                <style>{`
                    /* MOBILE PHONES (< 768px, e.g. iPhone SE, iPhone XR) */
                    @media (max-width: 767px) {
                        .hero-slider-section {
                            height: auto !important;
                            min-height: 460px !important;
                            max-height: none !important;
                            padding-top: 95px !important;
                            padding-bottom: 60px !important;
                        }
                        .hero-slider-section .container {
                            padding-left: 52px !important;
                            padding-right: 52px !important;
                        }
                        .hero-slider-tag {
                            font-size: 10.5px !important;
                            padding: 3px 10px !important;
                            margin-bottom: 12px !important;
                        }
                        .hero-slider-title {
                            font-size: 22px !important;
                            line-height: 1.25 !important;
                            margin-bottom: 12px !important;
                        }
                        .hero-slider-desc {
                            font-size: 13.5px !important;
                            line-height: 1.55 !important;
                            margin-bottom: 18px !important;
                            text-align: left !important;
                        }
                        .hero-slider-btn {
                            padding: 10px 22px !important;
                            font-size: 13px !important;
                        }
                        .hero-slider-arrow-prev {
                            left: 8px !important;
                            width: 36px !important;
                            height: 36px !important;
                            font-size: 14px !important;
                        }
                        .hero-slider-arrow-next {
                            right: 8px !important;
                            width: 36px !important;
                            height: 36px !important;
                            font-size: 14px !important;
                        }
                    }

                    /* TABLETS (768px to 1024px width, e.g. 768x1024 iPad Mini) */
                    @media (min-width: 768px) and (max-width: 1024px) {
                        .hero-slider-section {
                            height: 480px !important;
                            min-height: 480px !important;
                            max-height: 480px !important;
                            padding-top: 80px !important;
                        }
                        .hero-slider-section .container {
                            padding-left: 65px !important;
                            padding-right: 65px !important;
                        }
                        .hero-slider-title {
                            font-size: 30px !important;
                            line-height: 1.25 !important;
                        }
                        .hero-slider-desc {
                            font-size: 15px !important;
                        }
                        .hero-slider-arrow-prev {
                            left: 14px !important;
                            width: 42px !important;
                            height: 42px !important;
                        }
                        .hero-slider-arrow-next {
                            right: 14px !important;
                            width: 42px !important;
                            height: 42px !important;
                        }
                    }
                `}</style>

                {/* SLIDE BACKGROUND IMAGE - SINGLE IMAGE ONLY WITHOUT BLENDING */}
                {slideBgUrl && (
                    <div
                        className="slider-bg-img"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.45) 100%), url(${slideBgUrl})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center center'
                        }}
                    />
                )}

                {/* SLIDE CONTENT CONTAINER */}
                {currentSlide && (
                    <div className="container" style={{ position: 'relative', zIndex: 10, height: '100%', display: 'flex', alignItems: 'center' }}>
                        <div style={{ maxWidth: '720px', color: '#ffffff' }}>
                            <div className="hero-slider-tag" style={{ display: 'inline-block', backgroundColor: '#f03a02', color: '#fff', fontSize: '12px', fontWeight: '800', padding: '4px 14px', borderRadius: '20px', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '18px' }}>
                                {currentSlide.tag}
                            </div>
                            <h1 className="hero-slider-title" style={{ fontFamily: "'Poppins', sans-serif", fontSize: 'clamp(24px, 4.5vw, 48px)', fontWeight: '900', lineHeight: '1.18', color: '#ffffff', marginBottom: '18px', textTransform: 'uppercase' }}>
                                {currentSlide.title}
                            </h1>
                            <p className="hero-slider-desc" style={{ fontSize: 'clamp(14px, 1.8vw, 16px)', lineHeight: '1.6', color: '#dddddd', marginBottom: '26px', textShadow: '0 2px 4px rgba(0,0,0,0.6)' }}>
                                {currentSlide.description}
                            </p>
                            <div>
                                <NavLink to={currentSlide.link || "/products"} className="site-button hero-slider-btn" style={{ backgroundColor: '#f03a02', color: '#fff', padding: '14px 36px', borderRadius: '6px', fontSize: '15px', fontWeight: '700', textTransform: 'uppercase', textDecoration: 'none', display: 'inline-block', boxShadow: '0 4px 15px rgba(240, 58, 2, 0.4)' }}>
                                    {currentSlide.btnText || "Explore Services"}
                                </NavLink>
                            </div>
                        </div>
                    </div>
                )}

                {/* ARROW NAV BUTTONS */}
                <button onClick={this.prevSlide} className="hero-slider-arrow-prev" aria-label="Previous Slide" style={{ position: 'absolute', top: '50%', left: '20px', transform: 'translateY(-50%)', zIndex: 20, background: 'rgba(0,0,0,0.5)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', width: '46px', height: '46px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', cursor: 'pointer', transition: 'all 0.3s ease' }}>
                    <i className="fa fa-chevron-left" />
                </button>
                <button onClick={this.nextSlide} className="hero-slider-arrow-next" aria-label="Next Slide" style={{ position: 'absolute', top: '50%', right: '20px', transform: 'translateY(-50%)', zIndex: 20, background: 'rgba(0,0,0,0.5)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', width: '46px', height: '46px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', cursor: 'pointer', transition: 'all 0.3s ease' }}>
                    <i className="fa fa-chevron-right" />
                </button>

                {/* DOT INDICATORS */}
                <div style={{ position: 'absolute', bottom: '22px', left: '50%', transform: 'translateX(-50%)', zIndex: 20, display: 'flex', gap: '10px' }}>
                    {displaySlides.map((s, idx) => (
                        <button
                            key={idx}
                            onClick={() => this.goToSlide(idx)}
                            aria-label={`Slide ${idx + 1}`}
                            style={{
                                width: idx === activeSlide ? '30px' : '10px',
                                height: '10px',
                                borderRadius: '5px',
                                backgroundColor: idx === activeSlide ? '#f03a02' : 'rgba(255,255,255,0.5)',
                                border: 'none',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                            }}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

export default Slider;
